export { default } from './ponyfillGlobal';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/ponyfillGlobal/index.js
// module id = 1727
// module chunks = 25